import React from "react";
import "./AboutUsHikayem.css";

const AboutUsHikayem = () => {
  return (
    <section className="hikayemiz-section">
      <p className="hikayemiz-baslik">Hikayemiz</p>

      <p className="hikayemiz-metin">
        <strong>Lingify’ın hikayesi</strong>, bir staj günü gönüllülük ile
        başlayan gözlem isteği ile başladı. Kurucumuzun dil ve konuşma terapisi
        lisans eğitimi sırasında katıldığı bir staj programında, değerlendirme
        amacıyla gönüllü olarak afazi vakalarına ulaşmaya başladı. İçlerinden
        bir kısmına gönüllü olarak 1.5 ay boyunca terapiye devam etti.
        İçlerinden bir danışan onu çok etkilemişti, terapi başındaki çaresiz ve
        ne yapacağını bilemeyen halden, hayat enerjisi dolu ve{" "}
        <strong>artık iletişim kurabilen biri haline gelmişti.</strong>
      </p>
      <br />

      <p className="hikayemiz-metin">
        Kısa bir sürede özverili terapi seanslarının ardından danışandaki
        gelişme, sadece terapistin değil, danışanın ve ailesinin hayatında da
        derin bir dönüşüm yarattı. Bu kısa süreli çalışmanın yarattığı etki, bir
        gerçeği gün yüzüne çıkardı:
        <br />
        <strong>
          Doğru zamanda ulaşılan doğru terapi, hayatları değiştirebilir.
        </strong>
      </p>

      <p className="hikayemiz-metin">
        Ancak bu başarı, aynı zamanda bir soruyu da beraberinde getirdi:
        <br />
        <strong>
          “Bu desteğe ulaşamayan binlerce insan için biz ne yapıyoruz?”
        </strong>
      </p>

      <p className="hikayemiz-metin">
        <br />
        İşte bu soru, Lingify’ın doğuş noktası oldu. Bu etkiyi çoğaltmak ve
        herkesin haklı olan terapiye erişimi mümkün kılmak için teknolojiyle
        yola çıkıldı. 2023 yılı itibariyle TÜBİTAK desteği ve Mükemmeliyet
        Mührü’nü de alarak resmi kimliğini kazanan Lingify, bugün dil ve konuşma
        terapisini yapay zeka destekli dijital çözümlerle erişilebilir ve
        sürdürülebilir hale getirmek için çalışıyor.
      </p>

      <p className="hikayemiz-metin">
        Her bir bireyin sesi duyulsun, her terapist daha fazla kişiye
        ulaşabilsin diye... <br />
        Lingify, şimdi danışanları ve terapistleri buluşmak için hazır.
      </p>
    </section>
  );
};

export default AboutUsHikayem;
